

import { defineComponent, onMounted, reactive, ref } from 'vue'
import {getWorkBannerListApi} from "@/api/api";
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'
import 'swiper/swiper-bundle.css'
import { baseApiUrl } from "@/config/apiConfig";
export default defineComponent ({
  name: 'BannerList',
  components: {
    Swiper,
    SwiperSlide,
  },
  setup () {

    const swiperRef = ref()

    const state = reactive<{
      swiper: any,
      list: any[],
       path: string;
    }>({
      list: [],
      swiper: null,
      path:''
    })
    onMounted(()=>{
       state.path = baseApiUrl;
       getBanner()
    })
    const onSwiper = (swiper: any) => {
      console.log('111', swiper);
      swiperRef.value = swiper
    }

    const getBanner = async () => {
      try {
        const result = await getWorkBannerListApi();
        if (result.status !== 200 || !result.data) return false;
        const { code, msg, data } = result.data;
        console.log('123',data.rows)
        if (data.rows && data.rows.length) {
          state.list = data.rows
     
        }
      } catch (e) {}
    };
    const handleSlideSwiper = (type: string) => {
      if (type === 'prev') {
        swiperRef.value.slidePrev()
      } else if (type === 'next') {
        swiperRef.value.slideNext()
      }
    }

    return {
      state,
      onSwiper,
      handleSlideSwiper,
    }
  }
})

